// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__30HGW","inputWrap":"CustomTip_inputWrap__2BVKU"};